
import fetch from '@/service/fetch';

// 角色列表
export const getRoleList = async (params) => {
  const res = await fetch.get('/system/role/list')(params);
  return res.data;
}

// 新增角色
export const addRole = async (params) => {
  const res = await fetch.post('/system/role/add')(params);
  return res.data
}

// 编辑角色
export const editRole = async (params) => {
  const res = await fetch.post('/system/role/edit')(params);
  return res.data;
}

// 删除角色
export const deleteRole = async (id) => {
  const res = await fetch.post('/system/role/delete')({ id });
  return res.data;
}

// 查询角色对应的权限
export const getRoleMenu = async (id) => {
  const res = await fetch.get('/system/role/getRoleMenu')({ id });
  return res.data;
}

// 保存角色对应的权限
export const saveRoleMenu = async (params) => {
  const res = fetch.post('/system/role/saveRoleMenu')(params);
  return res.data;
}

// 查询角色对应 用户
export const getRoleUser = async (params) => {
  const res = await fetch.get('/system/role/getRoleUser')(params);
  return res.data;
}

// 保存角色对应用户
export const saveRoleUser = async (params) => {
  const res = await fetch.post('/system/role/saveRoleUser')(params);
  return res.data;
}

// 移除用户
export const deleteRoleUser = async (idList) => {
  const res = await fetch.post('/system/role/deleteRoleUser')({ idList });
  return res.data;
}

// 角色选择用户
export const roleUserList = async (params) => {
  const res = await fetch.get('/system/role/userList')(params);
  return res.data
}